import ListListings from "../components/mainpage/ListListings"
import { ListingContextProvider } from "../context/ListingsContext"
import { useState } from "react"
import {
    collection,
    query,
    where,
    getDocs,
    and,
} from "firebase/firestore"
import { db } from "../firebase"
import { useEffect, useContext } from "react"
import { AuthContext } from "../context/AuthContext"

const ListingsArchive = () => {
    const [listings, setListings] = useState(null)

    const { currentUser } = useContext(AuthContext)

    const getListings = async() => {
        console.log("****")
        try {
            const q = query(collection(db, "listings"), and(where("user.email", "==", currentUser.email), where("active", "==", false)))
            const querySnapshot = await getDocs(q)
            const queryRes = []
            querySnapshot.forEach((doc) => {
                const docData = doc.data()
                docData.listing_id = doc.id
                queryRes.push(docData)
            })
            setListings(queryRes)
        } catch(err) {
            console.error(err.message)
        }
    }

    useEffect(() => {
        getListings()
    }, [currentUser])

    return (
        <ListingContextProvider>
            <div className='page-container'>
                <div className="my-page">
                    <div className="page-header">
                        <span className="header-text">Archive</span>
                    </div>
                    {
                        currentUser ? <ListListings listings={listings} className={"listings-grid-full-page"}></ListListings> : <div>Loading</div>
                    }
                </div>
            </div>
        </ListingContextProvider>
    )
}

export default ListingsArchive